export default energyConsultant => {

    if (!$('#energy_consultant').length) {
        return;
    }

    let $zipCode = $('#searchZip');
    let $searchHint = $('#searchHint');
    let $searchZipCode = $('#searchZipCode');
    let $errorMsg = $('#errorMsg');
    let $energyConsultantEL = $('#energy-consultant');
    let $energyConsultantList = $('#energyConsultantList');
    let $showEnergyConsultant = $('#showEnergyConsultant');
    let $energyConsultantError = $('#energyConsultantError');
    let $searchEnergyConsultant = $('#searchEnergyConsultant');
    let $premiumEnergyConsultant = $('#premiumEnergyConsultant');
    let $energyConsultant = $('#energyConsultant');
    let searchResult = null;

    $zipCode.on('keyup', function() {
        if ($zipCode.val().length !== 5) {
            hideHint();
            $errorMsg.hide();
            hideEnergyConsultant();
        } else {
            $searchZipCode.text($zipCode.val());
            getEnergyConsultant($zipCode.val());
            showHint();
            $energyConsultantError.hide();
        }
    });

    $searchEnergyConsultant.on('click', function() {
        if ($zipCode.val() == null ) return;

        $searchZipCode.text($zipCode.val());
        getEnergyConsultant($zipCode.val());
        showHint();
        $energyConsultantError.hide();
    });

    $showEnergyConsultant.on('click', function() {
        $energyConsultantList.toggle();
    });

    function getEnergyConsultant(zipCode) {
        if (searchResult !== null ) return;

        $.ajax({
            url: 'ajax/energy-consultant',
            type: 'POST',
            data: { zipCode }
        }).success(function (data) {
            if (data.error) {
                $energyConsultantError.show();
                $errorMsg.show().text(data.msg);
                $energyConsultantList.show();
            }
            if (data.result) {
                searchResult = JSON.parse(data.result);
                renderResult();
            }
        });
    }

    function renderResult() {
        if (searchResult !== null) {
            searchResult.forEach(function (item) {
                if (item.premium) {
                    $premiumEnergyConsultant.append(renderPremiumConsultant(item));
                } else {
                    $energyConsultant.append(renderConsultant(item));
                }
            });

            showEnergyConsultant();
        }
    }

    function hideHint() {
        $searchHint.hide();
    }

    function showHint() {
        $searchHint.show();
    }

    function showEnergyConsultant() {
        $energyConsultantEL.show();
    }

    function hideEnergyConsultant() {
        searchResult = null;
        $premiumEnergyConsultant.empty();
        $energyConsultant.empty();
        $energyConsultantEL.hide();
    }

    function renderConsultant(consultantData) {
        return ` <div class="medium-6 small-12 columns energy-consultant-wrapper">
            <div>
                <strong>${consultantData.headline}</strong><br>
                ${consultantData.firstName} ${consultantData.lastName}<br>
                ${consultantData.zipCode} ${consultantData.city}<br><br>
            </div>
        </div>`;
    }

    function renderPremiumConsultant(consultantData) {
        return `<div class="row">
            <div class="medium-8 small-12 columns energy-consultant-wrapper">
                <img class="energy-consultant-image" src="/uploads/images/portrait/${consultantData.portraitImage}" alt="" style="">
                <div>
                    <h3>${consultantData.headline}</h3>
                    ${consultantData.firstName} ${consultantData.lastName}<br>
                    ${consultantData.zipCode} ${consultantData.city}<br><br>
                </div>
            </div>
        
            <div class="medium-4 small-12 columns" style="display: flex;flex-direction: column;justify-content: center;align-items: center;">
                <a id="energy-consultant-route" href="energieberater/${consultantData.slug}" class="button success large text-right energy-consultant-route" style="bottom: 1.5rem;right: 1.5rem;font-size: 14px;">
                    Zum Berater-Profil
                </a>
            </div>
        </div>`;
    }
}
